import Vue from 'vue';
import dateFilter from './date.filter';

export default {
  install: () => {
    Vue.filter('date', dateFilter);
  }
}
